import { API_BASE } from '../config';

export { API_BASE };

export const apiFetch = async (endpoint, options = {}) => {
    // Try both the unified 'token' key and the legacy 'xemail_user' object
    let token = localStorage.getItem('token');
    if (!token) {
        const savedUser = localStorage.getItem('xemail_user');
        const user = savedUser ? JSON.parse(savedUser) : null;
        token = user?.token;
    }

    const headers = {
        ...options.headers,
    };

    if (!(options.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    // ALWAYS send in headers. Avoid sending in URL to prevent WAF blocks.
    // Guard: Only send token if it looks like a valid JWT (contains 2 periods)
    if (token && token.split('.').length === 3) {
        headers['Authorization'] = `Bearer ${token}`;
        headers['X-Token'] = token;
    } else if (token) {
        console.warn("⚠️ Filtering out malformed auth token:", token);
    }

    const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;

    const response = await fetch(url, {
        ...options,
        headers,
    });

    if (response.status === 401 || response.status === 403) {
        const errorText = await response.clone().text();
        console.error(`🚫 Backend rejected request - Status: ${response.status} for ${url}`);
        console.error(`🚫 Server response: ${errorText}`);
        
        // If 403, it often means the token is stale or invalid after server changes
        if (response.status === 403 && !endpoint.includes('/auth/login')) {
            console.warn("⚠️ Periodic session check failed or token invalid. Clearing session...");
            localStorage.removeItem('token');
            localStorage.removeItem('xemail_user');
            // We don't reload here to avoid infinite loops, 
            // but the App state will reflect user=null if we handle it in hooks
        }
    }

    return response;
};

export default apiFetch;
